import { render } from "./Banner-component.vue?vue&type=template&id=cf347e92&scoped=true"
import script from "./Banner-component.vue?vue&type=script&lang=js"
export * from "./Banner-component.vue?vue&type=script&lang=js"

import "./Banner-component.vue?vue&type=style&index=0&id=cf347e92&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf347e92"]])

export default __exports__